import React from "react";
import { Row } from "antd";
import Lands from "./assets/Lands";
import Metahuts from "./assets/Metahuts";
import Avatars from "./assets/Avatars";

const Assets = ({GetUser}) => {

    console.log('asstes Getuser', GetUser)

    return (
        <>
            {GetUser ?  
                <div className="assets">
                    <span className="block font-bold mb-10 meta-card-header">My Assets</span>
                    <Row gutter={44} className="assets-row">
                        <Metahuts  GetUser={GetUser}/>
                        <Lands GetUser={GetUser}/>
                        <Avatars GetUser={GetUser}/>
                    </Row>
                </div>
            :''}
        </>
    )

}

export default Assets;